import { inject, InjectionToken, Provider } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { RouteDataKey } from 'app/static/route-data-key.enum'

import { Links } from './cms.service'

export const LINKS = new InjectionToken<Links>(ngDevMode ? 'LINKS' : '')

export function provideLinksFromResolvedRouteData(): Provider[] {
  return [{ provide: LINKS, useFactory: () => inject(ActivatedRoute).snapshot.data[RouteDataKey.LINKS] }]
}
